// Vedoucí ikona řádku: skupina → složka, agenda → type-ikona dle resolveru,
// jinak decentní tečka (currentColor @ 40 %). Slot má pevnou šířku (drží zarovnání).

import { Icon } from '@/shared/ui/icon';

import { useMenuConfig } from './menuConfigContext';
import type { MenuGroupNode, MenuItemNode } from './menuTypes';

export interface LeadIconProps {
  readonly node: MenuItemNode | MenuGroupNode;
}

export function LeadIcon({ node }: LeadIconProps) {
  const { iconForNode, densityTokens } = useMenuConfig();
  const box = { width: densityTokens.leadSize, height: densityTokens.leadSize } as const;

  if (node.t === 'group') {
    return (
      <span
        className="text-phx-text-2 inline-flex shrink-0 items-center justify-center"
        style={box}
      >
        <Icon name="folder" size={13} />
      </span>
    );
  }

  // Externí WWW odkaz (link) → ikona „otevře externě" bez ohledu na resolver.
  if (node.url) {
    return (
      <span
        className="text-phx-text-muted inline-flex shrink-0 items-center justify-center"
        style={box}
      >
        <Icon name="external-link" size={12} />
      </span>
    );
  }

  const iconName = iconForNode(node);
  if (iconName) {
    return (
      <span
        className="text-phx-text-muted inline-flex shrink-0 items-center justify-center"
        style={box}
      >
        <Icon name={iconName} size={12} />
      </span>
    );
  }

  return (
    <span
      className="text-phx-text-muted inline-flex shrink-0 items-center justify-center opacity-40"
      style={box}
    >
      <span className="h-phx-2_5 w-phx-2_5 block rounded-full bg-current" />
    </span>
  );
}
